module.exports = __webpack_public_path__ + "img/groupie.f02e8a99.jpg";